import {
    AreaFormat,
    escapeHtml,
    FloorPlanElement,
    initializePlan,
    isBlockOfFlats,
    isBuilding,
    isFloor,
    isProperty,
    MoneyFormat,
    PlanElement,
    PlanElementType,
    PlanOptions, PlanProperty,
    PropertyStats,
    PropertyType,
    propertyTypeToString
} from "@vpsoftware/vprealestate-www";

export const planOptions: PlanOptions = {
    styles: {
        Regular: {
            fill: {
                type: 'pattern',
                lineColor: 'rgb(0, 0, 0, 0)',
                backgroundColor: 'rgb(255, 255, 255, 0)',
                lineWidth: 4,
                spacing: 11,
                angle: 45,
            },
            stroke: 'rgb(20, 20, 20, 0)',
            fillHover: {
                type: 'pattern',
                lineColor: 'rgb(0, 0, 0, 0.45)',
                backgroundColor: 'rgb(255, 255, 255, 0.2)',
                lineWidth: 3,
                spacing: 8,
                angle: 45,
            },
            strokeHover: 'rgb(20, 20, 20, 0.75)',
            thickness: 2

        },
        Available: { fill: 'rgb(0, 215, 0, 0.2)', stroke: 'rgb(0, 215, 0, 0.8)', fillHover: 'rgb(0, 215, 0, 0.4)', strokeHover: 'rgb(0, 215, 0, 1)', thickness: 2},
        Reserved: { fill: 'rgb(252, 235, 215, 0.6)', stroke: 'rgb(255, 255, 0, 0.4)', fillHover: 'rgb(252, 235, 215, 0.8)', strokeHover: 'rgb(255, 255, 0, 0.4)', thickness: 2},
        Sold: { fill: 'rgb(255, 0, 0, 0.2)', stroke: 'rgb(255, 0, 0, 0.4)', fillHover: 'rgb(255, 0, 0, 0.4)', strokeHover: 'rgb(255, 0, 0, 0.4)', thickness: 2}
    },
    getPopoverTitle: popoverTitle,
    getPopoverContent: popoverContent,
    onClick: elementClick,
    popoverPlacement: "top",
    getElementStyle
};

export const propertyPlanOptions: PlanOptions = {
    styles: {
        Regular: { fill: 'rgb(247, 215, 128, 0.4)', stroke: 'rgb(247, 215, 128, 0.4)'}
    },
    popoversEnabled: false,
    getElementStyle: _ => 'Regular'
};

function getElementStyle(element: PlanElement) {
    if (isProperty(element)) {
        return element.st;
    }
    return 'Regular';
}

function elementClick(element: PlanElement) {
    if (isFloor(element)) {
        loadFloor(element);
        return;
    }
    if (!element.url || (isProperty(element) && ![PropertyType.Flat, PropertyType.Premises, PropertyType.House].includes(element.pt))) return;
        document.location = element.url;
}

export function loadFloor(floor: FloorPlanElement) {
    document.querySelectorAll<HTMLElement>("table.offer-table .table-details").forEach(toggleElement =>{
        toggleElement.classList.toggle('open', false);
        toggleElement.closest('tr').nextElementSibling.classList.remove('d-none');
        toggleElement.closest('tr').nextElementSibling.classList.remove('more-info-house-open');
    });
    let floorPlanContainer = document.getElementById('floor-plan-container');
    Array.from(floorPlanContainer.children).forEach(c => (c as HTMLElement).classList.add('d-none'));
    if (!floor.plUrl || !floor.pr) {
        return;
    }


    let hasPrev = false;
    floorPlanContainer.childNodes.forEach(x => {
        if (!(x instanceof HTMLElement)) return;
        if (x.dataset.floor === '' + floor.fl) {
            x.classList.remove('d-none');
            hasPrev = true;
        }
    });
    if (hasPrev) return;
    let newPicture = document.createElement('picture');
    newPicture.innerHTML = `
        <source srcset="${floor.plUrl}?format=webp" type="image/webp"/>
        <img src="${floor.plUrl}" alt="${floor.n} - plan"/>`;

    newPicture.classList.add('floor-plan', 'clickable-plan', 'plan-image');
    newPicture.dataset.floor = '' + floor.fl;

    floorPlanContainer.appendChild(newPicture);
    initializePlan(newPicture, floor.pr, planOptions);
    floorPlanContainer.scrollIntoView({behavior: 'smooth', block: 'center'});

    let estateEntries = document.querySelectorAll<HTMLDivElement>('.estate-list-section .estate-list-row');
    estateEntries.forEach(e => {
        e.classList.toggle('d-none', e.dataset.floor !== '' + floor.fl);
    });
}

export function loadFloorLevel(level: number) {
    let floorPlanContainer = document.getElementById('floor-plan-container');
    Array.from(floorPlanContainer.children).forEach(c => (c as HTMLElement).classList.add('d-none'));
}

function popoverTitle(_: PlanElement) {
    return null;
}

function popoverContent(obj: PlanElement) {
    if (isBlockOfFlats(obj) || isFloor(obj)) {
        return formatPropertyStats(obj);
    }
    if (isProperty(obj)) {
        let result = '<div class="popover-info">';
        result += popoverPropertyData(obj);
        result += '</div>';
        return result;
    }

    if(isBuilding(obj)){
        if(obj.t === 'mp'){
            let result = '<div class="popover-info">';
            result += `<div class="span-all primary-text fw-bold fs-3 text-nowrap">Dom dwulokalowy</div>`;
            result += `<hr class="w-100 text-secondary">`
            if(obj.bfl && obj.bfl.length > 0){
                obj.bfl.forEach((prop: PlanProperty, index: number) => {
                   result += popoverPropertyData(prop);
                   if(index === 0)
                       result += `<hr class="w-100 text-secondary">`;
                });
            }
            result += '</div>';
            return result;
        }
    }

}

function popoverPropertyData(obj: PlanProperty){
    let result = '';
    let typeStr = propertyTypeToString(obj.pt);
    let numberStr = obj.pn ? `${typeStr} nr ${obj.pn}` : `${obj.n}`;
    result += `<div class="span-all primary-text fw-bold fs-4 text-nowrap">${escapeHtml(numberStr)}</div>`;

    if(obj.isChild && !obj.dynamicOwner && obj.ownerAddress){
        result += `<div class="info text-nowrap">Przypisane do <strong>${obj.ownerAddress}</strong></div>`
        result += '</div>';
        return result;
    }

    if (obj.a) {
        result += `<div class="info"><div class="descr">Powierzchnia:</div><div>${AreaFormat.format(obj.a)}&nbsp;m²</div></div>`;
    }

    if (obj.tr) {
        if (obj.pt === PropertyType.Premises) {
            result += `<div class="info"><div class="descr">Ilość pomieszczeń:</div><div>${obj.tr}</div></div>`;
        } else {
            result += `<div class="info"><div class="descr">Ilość pokoi:</div><div>${obj.tr}</div></div>`;
        }
    }

    if (obj.tp ) {
        result += `<div class="info"><div class="descr">Cena brutto:</div><div>`;
        result += `<div>${MoneyFormat.format(obj.tp)}&nbsp;PLN</div>`;
        if (obj.top && obj.top > obj.tp)
            result += `<div class="old-price">${MoneyFormat.format(obj.top)}&nbsp;PLN</div>`;
        result += `</div></div>`;
    }

    if (obj.npr) {
        result += `<div class="info"><div class="descr">Cena netto:</div><div>`;
        result += `<div>${MoneyFormat.format(obj.npr)}&nbsp;PLN</div>`;
        if (obj.npr && obj.norgPr > obj.npr)
            result += `<div class="old-price">${MoneyFormat.format(obj.norgPr)}&nbsp;PLN</div>`;
        result += `</div></div>`;
    }

    if(obj.childProperties && obj.childProperties.length > 0){
        let objPrice = '';
        if(obj.orgPr && obj.orgPr > obj.pr){
            objPrice += `<div class="d-flex flex-column text-secondary">`;
            objPrice += `<div>${MoneyFormat.format(obj.pr)}&nbsp;PLN</div>`;
            objPrice += `<div class="old-price">${MoneyFormat.format(obj.orgPr)}&nbsp;PLN</div>`;
            objPrice += `</div>`
        }
        else {
            objPrice = `${MoneyFormat.format(obj.pr)}&nbsp;PLN`;
        }
        if(obj.pt == PropertyType.Flat){
            result += `<div class="info text-nowrap d-flex align-items-center text-secondary bullet-point">Mieszkanie: ${objPrice}</div>`;
        }else if (obj.pt == PropertyType.House) {
            result += `<div class="info text-nowrap d-flex align-items-center text-secondary bullet-point">Dom: ${objPrice}</div>`;
        }else if (obj.pt == PropertyType.Premises) {
            result += `<div class="info text-nowrap d-flex align-items-center text-secondary bullet-point">Lokal: ${objPrice}</div>`;
        }

        obj.childProperties.forEach(childProperty => {
            let price = '';
            if(childProperty.orgPr && childProperty.orgPr > childProperty.pr){
                price += `<div class="d-flex flex-column text-secondary">`;
                price += `<div>${MoneyFormat.format(childProperty.pr)}&nbsp;PLN</div>`;
                price += `<div class="old-price">${MoneyFormat.format(childProperty.orgPr)}&nbsp;PLN</div>`;
                price += `</div>`
            }
            else if(childProperty.pr) {
                price = `: ${MoneyFormat.format(childProperty.pr)}&nbsp;PLN`;
            }
            result += `<div class="info span-all text-nowrap d-flex align-items-center text-secondary bullet-point">${childProperty.name} ${price}</div>`;
            if(childProperty.features && childProperty.features.length > 0){
                childProperty.features.filter(x => x.price).forEach(feature => {
                    result += `<div class="info span-all text-nowrap text-secondary bullet-point-further">${feature.name}: ${MoneyFormat.format(feature.price)}&nbsp;PLN</div>`;
                });
            }
        });
    }

    if(obj.features && obj.features.length > 0){
        obj.features.filter(x => x.price).forEach(feature => {
            result += `<div class="info span-all text-nowrap text-secondary bullet-point">${feature.name}: ${MoneyFormat.format(feature.price)}&nbsp;PLN</div>`;
        });
    }

    switch (obj.st) {
        case "Available":
            result +=
                `<div class="span-all text-center">
            <span class="label-available">Dostępne</span>
          </div>`;
            break;
        case "Reserved":
            result +=
                `<div class="span-all text-center">
            <span class="label-reserved">Rezerwacja</span>
          </div>`;
            break;
        case "Sold":
            result +=
                `<div class="span-all text-center">
            <span class="label-unavailable">Sprzedane</span>
          </div>`;
            break;
    }
    return result;
}

function formatPropertyStats(obj: {ps?: PropertyStats, n: string}) {
    let result = '<div class="popover-info">';

    result += `<div class="span-all primary-text fw-bold fs-4">${escapeHtml(obj.n)}</div>`;
    if (obj.ps) {
        let atLeastOne = false;
        if (obj.ps.fl > 0) {
            result += `<div class="info"><div class="text-nowrap">Liczba dostępnych mieszkań:</div><div>${obj.ps.fl}</div></div>`;
            atLeastOne = true;
        }
        if (obj.ps.pr > 0) {
            result += `<div class="info"><div class="text-nowrap">Liczba dostępnych lokali usługowych:</div><div>${obj.ps.pr}</div></div>`;
            atLeastOne = true;
        }
        if (obj.ps.gr > 0) {
            result += `<div class="info"><div class="text-nowrap">Liczba dostępnych garaży:</div><div>${obj.ps.gr}</div></div>`;
            atLeastOne = true;
        }
        if (!atLeastOne) {
            result += `<div class="span-all text-nowrap">Wyprzedane</div>`;
        }
    }

    result += `</div>`;
    return result;
}
